import produce from "immer";
import { AddJobStepsEnum } from "../types";
import names, { AddJobActionTypes } from "./addJobActionTypes";
import { AddJobState } from "./addJobState";

export const addJobReducer = (state: AddJobState, action: AddJobActionTypes) =>
    produce(state, draft => {
        switch (action.type) {
            case names.ATTACHMENT_UPLOAD_STARTED: {
                draft.ui.isLoading = true;
                break;
            }

            case names.ATTACHMENT_UPLOAD_SUCCESS: {
                draft.ui.errors = state.ui.errors.filter(
                    e => e.type !== "attachmentUpload"
                );
                draft.ui.isLoading = false;
                break;
            }

            case names.ATTACHMENT_UPLOAD_FAILURE: {
                draft.ui.errors.push({
                    type: "attachmentUpload",
                    message: action.payload.message,
                    apiError: action.payload.apiError,
                });
                draft.ui.isLoading = false;
                break;
            }

            case names.LOAD_ADD_JOB_STEP_1: {
                draft.ui.isLoading = true;
                break;
            }

            case names.LOAD_ADD_JOB_STEP_1_SUCCESS: {
                draft.data.teams = action.payload.teams;
                draft.ui.showOrderConfirmationStep =
                    action.payload.showOrderDetails;
                draft.ui.isLoading = false;
                draft.data.jobId = action.payload.jobId;
                break;
            }

            case names.LOAD_ADD_JOB_STEP_1_FAILURE: {
                draft.ui.error = {
                    type: "addJob",
                    apiError: action.payload.apiError,
                    currentStep: AddJobStepsEnum.Step1,
                };
                draft.ui.isLoading = false;
                break;
            }

            case names.SAVE_ADD_JOB_STEP_1: {
                draft.ui.isLoading = true;
                break;
            }

            case names.SAVE_ADD_JOB_STEP_1_SUCCESS: {
                draft.ui.isLoading = false;
                draft.data.jobId = action.payload.jobId;
                draft.ui.isStepValid.one = true;
                draft.ui.showOrderConfirmationStep =
                    action.payload.showOrderDetails;
                draft.ui.stepOneValidationErrors = null;
                draft.ui.error = null;
                break;
            }

            case names.SAVE_ADD_JOB_STEP_1_FAILURE: {
                draft.ui.isLoading = false;
                draft.ui.stepOneValidationErrors =
                    action.payload.apiError?.validationErrors;
                draft.ui.error = {
                    type: "addJob",
                    apiError: action.payload.apiError,
                    currentStep: AddJobStepsEnum.Step1,
                };
                draft.ui.isStepValid.one = false;
                break;
            }

            case names.LOAD_ADD_JOB_STEP_2: {
                draft.ui.isLoading = true;
                break;
            }

            case names.LOAD_ADD_JOB_STEP_2_SUCCESS: {
                draft.ui.isLoading = false;
                break;
            }

            case names.LOAD_ADD_JOB_STEP_2_FAILURE: {
                draft.ui.error = {
                    type: "addJob",
                    apiError: action.payload.apiError,
                    currentStep: AddJobStepsEnum.Step2,
                };
                draft.ui.isLoading = false;
                break;
            }

            case names.SAVE_ADD_JOB_STEP_2: {
                draft.ui.isLoading = true;
                break;
            }

            case names.SAVE_ADD_JOB_STEP_2_SUCCESS: {
                draft.ui.isLoading = false;
                draft.ui.isStepValid.two = true;
                draft.ui.stepTwoValidationErrors = null;
                draft.ui.error = null;
                break;
            }

            case names.SAVE_ADD_JOB_STEP_2_FAILURE: {
                draft.ui.isLoading = false;
                draft.ui.stepTwoValidationErrors =
                    action.payload.apiError?.validationErrors;
                draft.ui.error = {
                    type: "addJob",
                    apiError: action.payload.apiError,
                    currentStep: AddJobStepsEnum.Step2,
                };
                draft.ui.isStepValid.two = false;
                break;
            }

            case names.LOAD_ADD_JOB_STEP_3: {
                draft.ui.isLoading = true;
                break;
            }

            case names.LOAD_ADD_JOB_STEP_3_SUCCESS: {
                draft.ui.isLoading = false;
                break;
            }

            case names.LOAD_ADD_JOB_STEP_3_FAILURE: {
                draft.ui.error = {
                    type: "addJob",
                    apiError: action.payload.apiError,
                    currentStep: AddJobStepsEnum.Step3,
                };
                draft.ui.isLoading = false;
                break;
            }

            case names.MOVE_JOB_TO_REQUESTED: {
                draft.ui.isLoading = true;
                break;
            }

            case names.MOVE_JOB_TO_REQUESTED_SUCCESS: {
                draft.ui.isLoading = false;
                draft.data.jobManagerDetails = action.payload.jobManager;
                draft.ui.isJobMovedToRequested = true;
                draft.ui.activeStepId = AddJobStepsEnum.Finish;
                break;
            }

            case names.MOVE_JOB_TO_REQUESTED_FAILURE: {
                draft.ui.isLoading = false;

                draft.ui.stepOneValidationErrors = action.payload.apiError?.validationErrors?.filter(
                    e => e.field.startsWith("stepOne")
                );

                draft.ui.stepTwoValidationErrors = action.payload.apiError?.validationErrors?.filter(
                    e => e.field.startsWith("stepTwo")
                );

                draft.ui.error = {
                    type: "addJob",
                    apiError: action.payload.apiError,
                    currentStep: null,
                };
                break;
            }

            //Copy Job
            case names.COPY_JOB: {
                draft.ui.isLoading = true;
                break;
            }

            case names.COPY_JOB_SUCCESS: {
                draft.data.jobId = action.payload.jobId;
                draft.ui.isLoading = false;
                break;
            }

            case names.COPY_JOB_FAILURE: {
                draft.ui.error = {
                    type: "addJob",
                    apiError: action.payload.apiError,
                };
                draft.ui.isLoading = false;
                break;
            }

            case names.HANDLE_NEXT_STEP: {
                switch (draft.ui.activeStepId) {
                    case AddJobStepsEnum.Step1: {
                        if (draft.ui.isStepValid.one) {
                            draft.ui.activeStepId = AddJobStepsEnum.Step2;
                        }
                        break;
                    }
                    case AddJobStepsEnum.Step2: {
                        if (draft.ui.isStepValid.two) {
                            draft.ui.activeStepId = AddJobStepsEnum.Step3;
                        }
                        break;
                    }
                }
                break;
            }

            case names.HANDLE_PREVIOUS_STEP: {
                switch (draft.ui.activeStepId) {
                    case AddJobStepsEnum.Step2: {
                        draft.ui.activeStepId = AddJobStepsEnum.Step1;
                        break;
                    }
                    case AddJobStepsEnum.Step3: {
                        draft.ui.activeStepId = AddJobStepsEnum.Step2;
                        break;
                    }
                }
                break;
            }

            // UI
            case names.CLEAR_ERROR: {
                draft.ui.error = undefined;
                break;
            }
            case names.EXIT: {
                draft.ui.activeStepId = AddJobStepsEnum.Exit;
                draft.data.jobId = action.payload.jobId;
                break;
            }
        }
    });
